import React, { useContext } from "react";
import {
  HarmonyDetailsContentInterface,
  HarmonyDetailsProps,
} from "../../entities/HarmonyDetails";
import { HarmonyDetailsInfoStyled } from "./HarmonyDetailsInfoStyled";
import Typography from "../../UI/Typography/Typography";
import { TYPOGRAPHY_TYPE } from "../../entities/Typography";
import { TranslationContext } from "../../context/TranslationContext";
import { TranslationContextInterface } from "../../entities/Language";
import { getValueForKey } from "../../context/translationsUtils";
import Flex from "../../UI/Flex";
import { FLEX_ALIGN, JUSTIFY_CONTENT } from "../../entities/Flex";
import { transformArrayToString } from "../../utils/product";
import ImageComponent from "../../UI/ImageComponent";

const HarmonyDetailsInfo: React.FC<HarmonyDetailsProps> = ({
  condiment,
}: HarmonyDetailsProps) => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);

  const harmonyDetailsInfoContent: HarmonyDetailsContentInterface[] = [
    {
      title: getValueForKey(
        translations,
        "taste_harmony.additional_information_hint",
      ),
      content: condiment.description,
    },
    {
      title: getValueForKey(translations, "taste_harmony.latin_names_hint"),
      content: transformArrayToString(condiment.latinNames),
    },
    {
      title: getValueForKey(
        translations,
        "taste_harmony.botanical_origin_hint",
      ),
      content: transformArrayToString(condiment.botanicalOrigins),
    },
    {
      title: getValueForKey(translations, "taste_harmony.spice_history_hint"),
      content: condiment.history,
    },
  ];

  return (
    <HarmonyDetailsInfoStyled>
      <div className="harmony-details__name">
        <Typography type={TYPOGRAPHY_TYPE.TITLE_FOUR}>
          {condiment.name}
        </Typography>
      </div>
      <Flex
        styles={{
          justify: JUSTIFY_CONTENT.SPACE_BETWEEN,
          align: FLEX_ALIGN.FLEX_START,
        }}
      >
        <div className="harmony-details__left">
          <div className="harmony-details__image">
            <ImageComponent name={condiment.name} url={condiment.image} />
          </div>
        </div>
        <div className="harmony-details__right">
          {harmonyDetailsInfoContent.map((item, index: number) => (
            <div className="harmony-details__group" key={index}>
              <Typography type={TYPOGRAPHY_TYPE.BOLD}>{item.title}</Typography>
              <Typography type={TYPOGRAPHY_TYPE.REGULAR}>
                {item.content}
              </Typography>
            </div>
          ))}
        </div>
      </Flex>
    </HarmonyDetailsInfoStyled>
  );
};

export default HarmonyDetailsInfo;
